<lex-sidenav-container>
  <ng-container left>
    <div></div>
    <lex-account-search [(selectedAccount)]="selectedAccount" (selectedAccountChange)="selectAccount()" [selectedAccountId]="selectedAccountId" [source]="'manage-user'"></lex-account-search>
    <div></div>
  </ng-container>

  <!--Manage User Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;" *ngIf="!selectedUser">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Total Users: {{users.length}}</mat-card-title>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
              <button mat-icon-button id="addUser" matTooltip="Create New User In Account" *ngIf="selectedAccount" (click)="addUser()"><mat-icon>add</mat-icon></button>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <div style="font-size: 15px" *ngIf="!selectedAccount">
                No Account Selected
              </div>
              <div style="font-size: 15px" *ngIf="selectedAccount && users.length === 0">
                No Users in Account
              </div>
              <mat-card-content *ngIf="selectedAccount && users.length > 0">
                <table matSort (matSortChange)="sortData($event)" width="100%">
                  <tr style="color: #1a237e;">
                    <th mat-sort-header="userName" width="25%" class="custom-header-column-colors"> User Name </th>
                    <th mat-sort-header="userType" width="25%" class="custom-header-column-colors"> User Type </th>
                    <th mat-sort-header="caseCount" width="25%" class="custom-header-column-colors"> Number of Cases </th>
                    <th mat-sort-header="twoFactorEnabled" width="20%" class="custom-header-column-colors"> Two Factor Authentication </th>
                    <th width="5%"></th>
                  </tr>

                  <tr class="mat-row" [attr.id]="'manageUser.'+user.userId" *ngFor="let user of sortedData" (mouseover)="onMouseOverRow(user)" (mouseout)="onMouseOutRow()" (click)="selectedUser = user">
                    <td>{{user.userName}}</td>
                    <td>{{accountUserTypes.byString(user.userType).name}}</td>
                    <td>
                    <span matTooltipClass="tooltip-list" [matTooltipPosition]="'right'" style="padding-left: 7px" *ngIf="user.caseIds.length !== 0" [matTooltip]="selectedCases | tooltipList">{{user.caseIds.length}}</span>
                    <span matTooltipClass="tooltip-list" [matTooltipPosition]="'right'" style="color: #FFC107;" *ngIf="user.caseIds.length === 0" matTooltip="Warning: User Has No Case Access">
                      <mat-icon style="vertical-align: bottom; height:22px; width: 22px; float: left;">warning</mat-icon>
                    </span>
                    </td>
                    <td><span [style.visibility]="user.twoFactorEnabled ? 'visible' : 'hidden'"><mat-icon>check</mat-icon></span></td>
                    <td><button mat-icon-button [attr.id]="'removeUserFromAccount.'+user.userId"  matTooltip="Remove User From Account" [style.visibility]="user.userId !== hoverFieldId ? 'hidden': 'visible'" (click)="removeUser($event, user.userId)" style="pointer-events: auto;"><mat-icon>close</mat-icon></button></td>
                  </tr>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>
    <lex-manage-user-edit *ngIf="selectedUser" style="flex: 1 1 0%; box-sizing: border-box;" [accountId]="selectedAccount.accountId" [user]="selectedUser" (clearSelectionChange)="clearSelectedUser($event)"></lex-manage-user-edit>
  </ng-container>
</lex-sidenav-container>
